import {FC} from 'react'
import {SUB_STRING_METHOD} from 'interfaces'
import {checkTextOverflowed} from 'utils'

interface Props {
  textColor?: string
  subString: string
  data: string
  method?: SUB_STRING_METHOD
  classNames?: string
  dataCy?: string
}

export const ColorSubstring: FC<Props> = ({
  subString = '',
  data = '',
  method = SUB_STRING_METHOD.StartsWith,
  classNames = '',
  dataCy,
}) => {
  const indexOfSubstring = data?.toLowerCase().indexOf(subString?.toLowerCase())
  const isStartsWith = method === SUB_STRING_METHOD.StartsWith
  const isStartsWithMatch = isStartsWith && indexOfSubstring === 0
  const isIncludesMatch = !isStartsWith && indexOfSubstring >= 0
  const shouldHighlight = isIncludesMatch || isStartsWithMatch
  const matchEnd = indexOfSubstring + subString.length
  const prefix = shouldHighlight ? data.slice(0, indexOfSubstring) : data
  const match = shouldHighlight ? data.slice(indexOfSubstring, matchEnd) : ''
  const suffix = shouldHighlight ? data.slice(matchEnd) : ''

  return (
    <p
      className={`truncate ${classNames}`}
      role="button"
      tabIndex={0}
      onMouseOver={checkTextOverflowed}
      onKeyDown={checkTextOverflowed}
      data-cy={dataCy}
    >
      <span>{prefix}</span>
      <span className="text-dope-cyan-dark">{match}</span>
      <span>{suffix}</span>
    </p>
  )
}
